enum RegionType {
    COUNTRY = 'COUNTRY',
    CONTINENTS = 'CONTINENTS'
}

export default RegionType;
